<template>
  <f7-page>
    <f7-navbar :title="$t('title.cardTransfer')" :back-link="$t('action.back')"></f7-navbar>
    <f7-list form>
      <f7-list-input v-if="!isMe"
                     :label="$tc('label.user', 1)"
                     type="select"
                     :value="userId"
                     @input="chooseUser"
      >
        <option :value="0" disabled>{{$t('placeholder.chooseUser')}}</option>
        <option v-for="user in myTeamWithCards" :key="user.id" :value="user.id">{{user | userName}}</option>
      </f7-list-input>
      <f7-list-item>
        <f7-block>{{$t('text.amountOnCard', {balance: cardBalance, user: cardHolder})}}</f7-block>
      </f7-list-item>
      <f7-list-input :label="$t('label.amount')" :input="false">
        <div class="item-input-wrap" slot="input">
          <money v-model="amount" v-bind="money" maxlength="9"></money>
        </div>
      </f7-list-input>
      <f7-list-input v-if="isMe"
                     :label="$tc('label.budget', 1)"
                     type="select"
                     :value="budgetId"
                     @input="budgetId = $event.target.value"
      >
        <option :value="0" disabled>{{$t('placeholder.chooseBudget')}}</option>
        <option v-for="budget in activeBudgets" :key="budget.potId" :value="budget.potId">{{budget.name}}</option>
      </f7-list-input>
      <f7-block>
        <button type="submit" class="button button-big button-fill" @click.prevent="recall">
          {{$t('action.cardTransfer')}}
        </button>
      </f7-block>
    </f7-list>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'

  export default {
    name: 'card-transfer',
    computed: {
      cardBalance () {
        return this.card && this.card.status !== 'pending' ? this.formatMoney(this.card.currency, this.card.balance) : ''
      },
      cardHolder () {
        return this.isMe || !this.user ? this.$t('title.your') : this.userName(this.user) + '\'s'
      },
      isMe () {
        // TODO: this doesn't seem to work (at least for Joe Bloggs on local)
        return !this.$f7route.params.user_id
      },
      user () {
        return this.myTeamWithCards.find(u => u.id === this.userId)
      },
    },
    async created () {
      this.userId = parseInt(this.$f7route.params.user_id)
      if (!this.userId) {
        this.userId = this.currentUserId
        this.card = this.myCard
      } else this.$store.dispatch('fetchTeam')
      this.$store.dispatch('budgets/fetch')
      await this.fetchCard()
      if (this.card.status === 'pending') this.goBack()
    },
    data () {
      return {
        amount: 0,
        budgetId: 0,
        card: undefined,
        userId: undefined,
      }
    },
    methods: {
      chooseUser (e) {
        this.userId = parseInt(e.target.value)
        this.fetchCard()
      },
      async fetchCard () {
        if (this.isMe) await this.$store.dispatch('fetchCard')
        else this.card = await api.getCard(this.userId)
        this.$bus.$emit('card-update')
      },
      async recall () {
        const errors = []
        if (this.amount <= 0) errors.push(this.$t('validation.amount'))
        if (!this.userId) errors.push(this.$t('validation.chooseUser'))
        if (this.isMe && this.budgetId === 0) errors.push(this.$t('validation.chooseBudget'))
        if (errors.length > 0) this.$f7.dialog.alert(errors.join('<br>'), '')
        else {
          try {
            if (this.isMe) await api.postMyCardRefund(this.userId, this.amount, this.budgetId)
            else await api.postCardRefund(this.userId, this.amount)
            this.$f7.dialog.alert(this.$t('dialog.recall', {
              amount: this.formatMoney(this.card.currency, this.amount),
              user: this.cardHolder,
            }), '', this.fetchCard)
          } catch (error) {
            //TODO: i18n error message
            this.$f7.dialog.alert(error.response.data, '')
          }
        }
      },
    },
    mixins: [helpers],
  }
</script>

<style scoped>

</style>
